<template>
  <div class="about">
    <Header/>
    <div class="body">
      <div class="sobre">
        <h2 class="msgs"> Contato </h2>
        <div class="forms">
        	<div class="formulario">
        		<div class="div_inputs">
              <div class="inputWithIcon">
                <input type="text" name="nome" value="nome" v-model="nome" placeholder="Nome" class="input_txt">
                <font-awesome-icon class="icon" icon="user"/>
              </div>
              <div class="inputWithIcon">
                <input type="text" name="email" value="email" v-model="email" placeholder="Email" class="input_txt">
                <font-awesome-icon class="icon" icon="envelope"/>
              </div>
        		</div>
        		<div class="msg">
              <div class="inputWithIcon">
                <input type="text" name="mensagem" value="mensagem" v-model="mensagem" id="m" placeholder="Mensagem">
                <font-awesome-icon class="icon" icon="comment"/>
              </div>
        		</div>
            <div id="div_button">
              <button type="submit" v-on:click="enviar_email"  @click="$bvToast.show('example-toast')" class="btnSave" name="button">Enviar</button>
            </div><br>
            <div id="alert" style="display:none">
              Mensagem enviada com sucesso!
              <span class="closebtn" onclick="this.parentElement.style.display='none';">&times;</span>
            </div>
          </div>
        </div>
        <div class="contact">
          <p><b>contato@cursinhosapiencia.com.br</b></p>
        </div>
        <div id="localizacao">
          <div class="img_location">
            <p> <b> Unidade Santos </b> </p>
            <p class="wpplink"> <a href="https://wa.me/5513997499702"> <font-awesome-icon class="icon" :icon="['fab','whatsapp']" style="color:green"/> (13) 99749-9702 </a></p>
            <p>(13) 3877-0073</p>
            <p>(13) 99639-2735</p>
            <p>(13) 99749-9702</p>
            <!-- <p class="wpplink"> <a href="https://wa.me/5511974402201"> <font-awesome-icon class="icon" :icon="['fab','whatsapp']" style="color:green"/> (11) 97440.2201 </a></p> -->
            <p>Avenida Conselheiro Nébias, 754 - Sala 1704 Helbor Office, Boqueirão</p>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default{
  name: 'contato',
  data () {
    return{
      nome: '',
      email: '',
      mensagem: ''
    }
  },
  methods: {
    enviar_email () {
      if (this.nome == "" || this.email == "" || this.mensagem == "") {
        alert('Por favor, preencha todos os campos');
      }
      else {
        var postData = {
           name: this.nome,
           email: this.email,
           message: this.mensagem
        };
        let axiosConfig = {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
          }
         };
        this.axios
          .post('http://cursinhosapiencia.com.br/contact.php',postData, axiosConfig)
          .then(response => (console.log(this.info = response)))
        document.getElementById('alert').style.display = "block";
      }
    }
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style>
@import "../assets/style_padrao.css";

.forms{
	justify-content: center;
	display: flex;
	width: 100%;
}
.div_inputs{
  justify-content: center;
	display: flex;
  margin-left: 0;
}
.input_txt{
	width: 95%;
  margin-left: 3%;
}
.formulario{
  padding-top: 5%;
  padding-bottom: 5%;
}
.msg{
	display:block;
}
input{
  width: 100%;
  margin: 5% 2%;
  border:none;
  font-size:20px;
  border-bottom: solid 1px gray;
}
input[type="text"]:focus {
  box-shadow: 0px 1px yellowgreen;
}
.inputWithIcon input[type="text"] {
  padding-left: 70px;
}
.inputWithIcon {
  position: relative;
}
.inputWithIcon .icon {
  position: absolute;
  left: 3%;
  top: 40%;
  transition: 0.3s;
}
input[type="text"], input[type="email"] {
  outline: none;
  padding: 8px;
}
.btnSave{
  margin-top: 5%;
  width: 60%;
  font-size: 20px;
  background-color:yellowgreen;
  color:white;
  border: none;
  border-radius:5px;
}
p{
  word-wrap: break-word;
}
#santos{
  position: relative;
  float: left;
  width: 40%;
}
#sjc{
  position: relative;
  float: right;
  width: 40%;
}
#div_button{
  width: 100%;
  justify-content: center;
  display: flex;
}
.icon{
  color: #8B658B;
}
#alert {
  padding: 20px;
  background-color: lightblue;
  color: black;
}
.closebtn {
  margin-left: 15px;
  color: white;
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}
.closebtn:hover {
  color: black;
}
</style>
